export default function TableD({ children, ...rest }) {
  let icon = '';
  if (children.every((item) => /^yes$/gim.test(item))) {
    icon = String.fromCharCode(10003);
  } else if (children.every((item) => /^no$/gim.test(item))) {
    icon = String.fromCharCode(10007);
  }
  return (
    <td className="px-3 py-2" {...rest}>
      {icon || children}
    </td>
  );
}
